import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";

function Form() {
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter();

    const hiddenValues = {}

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id
    }

    const path = '/movements/';
    const paths = {
        endpointSave: config.endpoints.backend + 'movements/save',
        endpointGetById: config.endpoints.backend + 'movements/getById',
        endpointGetAllPrincipals: config.endpoints.backend + 'principals/getall',
        endpointGetAllMovementTypes: config.endpoints.backend + 'movementtypes/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Nova Movimentação",
        labelTitleEdit: "Editar Movimentação",
        labelTitleView: 'Visualizar Movimentação'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                {
                    name: 'pdc_principal_id',
                    type: 'select',
                    label: 'Dirigente',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllPrincipals,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'pdc_movement_type_id',
                    type: 'select',
                    label: 'Tipo de Movimentação',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllMovementTypes,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'movement_date',
                    type: 'date',
                    label: 'Data da Movimentação',
                    validations: {
                        required: true
                    },
                    columnSize: 6
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
